import styled from "styled-components";
import { MainWrapper } from "../../styled/common";

export const SummaryContainer = styled(MainWrapper)`
  display: grid;
  grid-template-columns: 49% 8% 42%;
`;

export const GuestPanel = styled(MainWrapper)`
  padding: 0;
`;

export const BookingPanel = styled(MainWrapper)`
  padding: 0;
`;


export const VerticalLine = styled.span`
  background-color: #dee2db;
  height: 330px;
  width: 1px;
`

export const VerticalLineContainer = styled.div`
  display:grid ;
  justify-content: center;
`